import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useRecoilValue } from 'recoil';
import { leftSideBarState } from 'recoils/common/menuState';

import useViewMode from 'hooks/common/useViewMode';

import { findActiveNavigation } from 'utils/menu/navigationUtil';

import { mobileMenuBarConst } from 'constants/common/menu/mobileMenuBarConst';

const useNavigation = () => {
  const location = useLocation();
  const { isMobile } = useViewMode();
  const lnbState = useRecoilValue(leftSideBarState);
  const [navigation, setNavigation] = useState(null);

  useEffect(() => {
    if (lnbState || isMobile) {
      const activeNav = findActiveNavigation(
        isMobile ? mobileMenuBarConst : lnbState,
        location.pathname
      );
      setNavigation(activeNav);
    }
  }, [lnbState, location.pathname]);

  return { navigation };
};

export default useNavigation;
